import { lazy } from 'react';
import { Outlet } from 'react-router-dom';

// project imports
import Loadable from 'components/Loadable';
import PluginAuthGuard from 'utils/route-guard/PluginAuthGuard';
import PluginLibraryGuard from 'utils/route-guard/PluginLibraryGuard';
import { getSubRoot } from '../utils/utils.jsx';
import { PLUGIN_PAGE_NAME, LIBRARY_PAGE_NAME } from '@/constants/globalConstants';
import { NavigationProvider } from '@/contexts/NavigationContext';

const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/404')));
const PluginLibraryPage = Loadable(lazy(() => import('@/pages/plugin/PluginLibraryPage')));

// ==============================|| PLUGIN ROUTING ||============================== //
// Same subroot-first scheme as MainRoutes/LoginRoutes, with
// 'plugin' as the final segment:
//  - /<subroot>/plugin           entry point, gated by PluginAuthGuard (validates ?token=)
//  - /<subroot>/plugin/library   the library page, gated by PluginLibraryGuard

const PluginRoutes = {
    path: getSubRoot(window.location.pathname),
    children: [
      {
        path: '',
        // Plugin routes live outside the Dashboard layout (where NavigationProvider is
        // normally mounted), but components like SelectedElementsAccordion need it.
        element: (
          <NavigationProvider>
            <Outlet />
          </NavigationProvider>
        ),
        children: [
          {
            path: PLUGIN_PAGE_NAME,
            element: <PluginAuthGuard />
          },
          {
            path: `${PLUGIN_PAGE_NAME}/${LIBRARY_PAGE_NAME}`,
            element: (
              <PluginLibraryGuard>
                <PluginLibraryPage />
              </PluginLibraryGuard>
            )
          }
        ]
      }
    ]
  };

export default PluginRoutes;
